export default "__VITE_ASSET__CMRcvXtX__"